import React from 'react';
import { generateBemCss } from 'general/js/helpers';
import { getHoleParBemClass } from './score-themes';
import { hasValue } from '../../../general/js/general-helpers';

const ScoreCell = ({ childCss, r2hAttributes, holePar, playerPar }) => {
    r2hAttributes = hasValue(r2hAttributes) ? r2hAttributes : {};

    const bemCss = generateBemCss('score-cell', [getHoleParBemClass(holePar, playerPar), 'has-border']);
    let playerParText = playerPar;

    if (!playerPar || playerPar === 0) {
        playerParText = '-';
    }

    return (
        <div className={`${childCss} ${bemCss}`} {...r2hAttributes}>{playerParText}</div>
    );
};

ScoreCell.defaultProps = {
    childCss: ''
};

export default ScoreCell;
